import Vue from 'vue';

export default {
  // 获取图片验证码
  getCaptchaImage () {
    return Vue.axios.get('/api/v1.0/captcha');
  },
  // 登录系统
  logonSystem (postData) {
    return Vue.axios.post('/api/v1.0/user-dashboard/user/login', postData);
  },
  // 获取字典表
  // CompanyTypeMap 主体类型
  getDictionaryList (params) {
    return Vue.axios.get('/api/v1.0/public/system/enums', {params});
  },
  // 获取OCR的ticket
  getOCRTicket() {
    return Vue.axios.get('/api/v1.0/public/ocr/ticket');
  },
  // OCR识别
  OCRIdentify (postData) {
    return Vue.axios.post('/api/v1.0/public/ocr/company', postData);
  },
  // 企业注册
  companyRegister (postData) {
    return Vue.axios.post('/api/v1.0/user-dashboard/user/register', postData);
  },
  // 重置密码
  resetPassword (postData) {
    return Vue.axios.post('/api/v1.0/user-dashboard/user/change/password', postData);
  },
  // 获取加密参数
  getEncryption (postData) {
    return Vue.axios.post('/api/v1.0/public/company/encrypt', postData);
  },
  // 获取用户信息
  getUserInfo () {
    return Vue.axios.get('/api/v1.0/user-dashboard/user/info');
  },
  // 修改信息
  editInfo (postData) {
    return Vue.axios.put('/api/v1.0/user-dashboard/user', postData);
  },
  // 获取退回记录
  getBackRecord () {
    return Vue.axios.get('/api/v1.0/user-dashboard/tracking/reject/list');
  }
};
